export default __webpack_public_path__ + "static/media/password.3a53408a.jpg";